import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class OpportunityService {

    appUrl = "";
    localAppUrl = "";
    appCore = "";
    accountApiUrl = "";
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient) {
        // this.appUrl = environment.apiUrl + "Lead/";
        this.appUrl = environment.opportunityUrl + "Opportunity/";
        this.localAppUrl = environment.localApiUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.accountApiUrl = environment.apiUrlAccount + "Account/";
    }

    getOpportunityConfigurations() {
        return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=opportunity`)
    }

    getAllStages(companyID: number) {
        return this.http.get<any>(this.appUrl + 'OpportunityStages')
            .toPromise()
            .then(res => res);
    }

    getAllCountries() {
        return this.http.get<any>(this.appCore + 'Country')
            .toPromise()
            .then(res => res);
    }

    getClosedReasons(groupId) {
        return this.http.get<any>(`${environment.opportunityUrl}Category?groupId=` + groupId);
    }

    addClosedReasons(data) {
        return this.http.post<any>(`${environment.opportunityUrl}Category`, data);
    }

    updateClosedReasons(data) {
        return this.http.put<any>(`${environment.opportunityUrl}Category`, data);
    }

    deleteClosedReasons(id) {
        return this.http.delete<any>(`${environment.opportunityUrl}Category/${id}`);
    }


    getAllCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllAsyncCities(stateId: number) {
        return this.http.get<any>(this.appCore + 'City', {
            params: new HttpParams().append("stateId", stateId.toString())
        })
            .toPromise();
    }

    getAllStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllAsyncStates(countryId: number) {
        return this.http.get<any>(this.appCore + 'State', {
            params: new HttpParams().append("countryId", countryId.toString())
        })
            .toPromise();
    }

    getAllSalutations() {
        return this.http.get<any>(environment.apiUrl + 'Salutation')
            .toPromise()
            .then(res => res);
    }

    getAllIndustries() {
        return this.http.get<any>(this.appCore + 'Industry')
            .toPromise()
            .then(res => res);
    }

    getAllTargets() {
        return this.http.get<any>(this.appCore + 'TargetList')
            .toPromise()
            .then(res => res);
    }

    getAllLeadStatus(groupId: number) {
        return this.http.get<any>(environment.apiUrl + 'Status/AllStatus/' + groupId)
            .toPromise()
            .then(res => res);
    }

    getAllSocialProfiles(socialProfileType) {
        return this.http.get<any>(environment.apiUrl + 'Type/AllTypes/' + socialProfileType)
            .toPromise()
            .then(res => res);
    }

    getAllPhoneTypes(phoneType) {
        return this.http.get<any>(environment.apiUrl + 'Type/AllTypes/' + phoneType)
            .toPromise()
            .then(res => res);
    }

    getAllEmailTypes() {
        return this.http.get<any>(environment.contactAPI + '/LionO360/2.0/API/Email/EmailType')
            .toPromise()
            .then(res => res);
    }

    getAllLeadTypes(groupID: number) {
        return this.http.get<any>(environment.apiUrl + 'Type/AllTypes/' + groupID)
            .toPromise()
            .then(res => res);
    }

    getAllEmployeesCount() {
        return this.http.get<any>(this.appCore + 'EmployeeCount')
            .toPromise()
            .then(res => res);
    }

    getAllRevenues() {
        return this.http.get<any>(this.appCore + 'AnnualRevenue')
            .toPromise()
            .then(res => res);
    }

    getAllSources(companyID: number) {
        return this.http.get<any>(this.appCore + 'Source', {
            params: new HttpParams().append("organizationId", companyID.toString())
        })
            .toPromise()
            .then(res => res);
    }

    getAllLeads(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, objectNamesList?) {
        let url = this.appUrl + "?organizationId=" + companyID + "&userId=" +
            userLoginID + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize +
            "&objectNameList=status&objectNameList=leadContacts&objectNameList=leadStatus&objectNameList=leadTypes&objectNameList=industry&objectNameList=source&objectNameList=annualRevenue&objectNameList=employeesRange&objectNameList=leadAddress"

        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }

    getAllLeadsExport(companyID: number, userLoginID: number, objectNamesList?) {
        let url = this.appUrl + "Export?organizationId=" + companyID + "&userId=" + userLoginID;
        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }

    getOpportunityById(id) {
        let url = this.appUrl + + id;
        return this.http.get<any>(url).toPromise();
    }

    getOpportunityByIdDetails(id) {
        let url = this.appUrl + 'V2/' + + id;
        return this.http.get<any>(url);
    }

    getLeadDetails(leadId) {
        return this.http.get<any>(this.appUrl + leadId)
            .toPromise()
            .then(res => res);
    }

    getLeadTaskDetails(leadTaskId) {
        return this.http.get<any>(environment.apiUrl + "Task/" + leadTaskId)
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    addLead(lead) {
        return this.http.post<any>(this.appUrl, lead, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    updateLead(lead) {
        return this.http.put<any>(this.appUrl, lead, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    convertLeadToAccount(lead) {
        return this.http.post<any>(this.appUrl + "ConvertToAccount", lead)
            .toPromise()
            .then(res => res);
    }

    updateLeadStage(leadStage) {
        let url = environment.apiUrlLead + "LeadAPI/Lead/Stage?id=" + leadStage.id + "&leadStageId=" + leadStage.leadStageId
        return this.http.put<any>(url, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    getLeadContacts(leadId) {
        return this.http.get<any>(this.appUrl + 'Contact', {
            params: new HttpParams().append("leadId", leadId)
        })
            .toPromise()
            .then(res => res);
    }

    updateContact(c) {
        return this.http.put<any>(environment.apiUrl + 'Contact', c)
            .toPromise()
            .then(res => res);
    }

    addContact(c) {
        return this.http.post<any>(this.appUrl + 'Contact', c)
            .toPromise()
            .then(res => res);
    }

    deleteContact(c) {
        return this.http.delete<any>(this.appUrl + 'Contacts/' + c.id)
            .toPromise()
            .then(res => res);
    }


    updateTask(c) {
        return this.http.put<any>(this.appUrl + 'leadContacts/' + c.id, c)
            .toPromise()
            .then(res => res);
    }

    addTask(c) {
        return this.http.post<any>(environment.apiUrl + 'ObjectTask', c)
            .toPromise()
            .then(res => res);
    }

    deleteTask(c) {
        return this.http.delete<any>(this.appUrl + 'leadContacts/' + c.id)
            .toPromise()
            .then(res => res);
    }

    getAllLeadPipelines() {
        return this.http.get<any>(this.localAppUrl + 'leadPipelines')
            .toPromise()
            .then(res => res);
    }

    getDashboardData() {
        return this.http.get<any>(this.localAppUrl + 'leadDashboard')
            .toPromise()
            .then(res => res);
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    uploadLead({ OrganizationId, CreatedSource, UserId, file }) {
        const formData = new FormData();
        formData.append('filesData', file);
        const url = `${this.appUrl}import?organizationId=${OrganizationId}&CreatedSource=${CreatedSource}&UserId=${UserId}`;
        return this.http.post(url, formData, { responseType: 'text' }).toPromise();
    }



    /* -----------------------Oppurtunity service-------------------------------------------- */
    getAllOpportunities() {
        return this.http.get<any>(this.appUrl + 'allOpportunities')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunitiesNameList(organizationId?, loginUserId?, search?,globalChannelId?: number) {
        let searchValue = search ? encodeURIComponent(search) : "";
        return this.http.get<any>(`${this.appUrl}OpportunitysWithName?isTerritory=true&search=${searchValue}${globalChannelId? '&channelId='+globalChannelId : ''}`, {
            headers: new HttpHeaders({
                "UserId": `${loginUserId}`,
                'OrganizationId': `${organizationId}`
            })
        })
    }

    getOpportunityStagesCount(companyID: number, pipelineId, filter, isOpportunityList = true, isActive, globalChannelId: number) {
        let listValue = isOpportunityList ? 1 : 0;
        return this.http.get<any>(this.appUrl + 'Count?organizationId=' + companyID + '&pipelineId='
            + pipelineId + "&filter=" + filter + '&includeopportunity=' + listValue + '&isActive=' + isActive + '&globalChannelId=' + globalChannelId)
            .toPromise()
            .then(res => res);
    }

    getAllOpportunityByPipelineId(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, pipelineId: number = 0, dateSearch, stageId?, searchValue?: string, seachFields?: string, options?, globalChannelId?: number, objectNamesList?) {
        stageId = stageId ? stageId : 0
        let url = this.appUrl + "AllOpportunityByPipelineId?organizationId=" + companyID + "&loginUserId=" +
            userLoginID + "&pipelineId=" + pipelineId + "&stageId=" + stageId + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + "&dateSearch=" + dateSearch + "&globalChannelId=" + globalChannelId
        /* if(stageId && stageId !==0){
            url = `${url}&stageId=${stageId}`;
        } */
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.isActive || !options.isActive) {
                url = `${url}&isActive=${options.isActive}`;
            }
        }
        if (!options || !options.sort) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${encodeURIComponent(searchValue)}&SearchColumns=${seachFields}`;
        }

        if (objectNamesList && objectNamesList.length > 0) {
            objectNamesList.forEach(element => {
                url = `${url}&objectNameList=${element}`;
            });
        }

        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res =>

            ({
                opportunity: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            })

            );
    }

    getAllOpportunity(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, searchValue?: string, seachFields?: string, stageId?, options?, objectNamesList?) {
        let url = this.appUrl + "AllOpportunity?organizationId=" + companyID + "&loginUserId=" +
            userLoginID + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize
        if (stageId && stageId !== 0) {
            url = `${url}&stageId=${stageId}`;
        }
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
        }
        if (!options || !options.sort) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${encodeURIComponent(searchValue)}&SearchColumns=${seachFields}`;
        }
        return this.http.get<any>(url, { observe: 'response' })
            .toPromise()
            .then(res =>

            ({
                opportunity: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            })

            );
    }

    getAllOpportunityExport(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, objectNamesList?) {
        let url = this.appUrl + "AllOpportunity?organizationId=" + companyID + "&loginUserId=" +
            userLoginID

        return this.http.get<any>(url)
            .toPromise()
            .then(res => res);
    }

    getAllOpportunityMockData(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, objectNamesList?) {
        return this.http.get<any>(this.localAppUrl + 'allOpportunities')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunitiesStages() {
        return this.http.get<any>(this.appUrl + 'opportunityStages')
            .toPromise()
            .then(res => res);
    }

    getAllRatings() {
        return this.http.get<any>(this.appCore + 'Rating')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunityPipelines() {
        return this.http.get<any>(this.appUrl + 'OpportunityPipelines')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunitiesPipelines() {
        return this.http.get<any>(this.localAppUrl + 'OpportunityPipelines')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunitySources() {
        return this.http.get<any>(this.appUrl + 'opportunitySources')
            .toPromise()
            .then(res => res);
    }

    getAllOpportunityDashboardData() {
        return this.http.get<any>(this.appUrl + 'opportunityDashboardData')
            .toPromise()
            .then(res => res);
    }

    updateOpportunityDashboardData(d) {
        // return this.http.put<any>(this.appUrl + 'opportunityDashboardData/' + d.id, d)
        //   .toPromise()
        //   .then(res => res);
    }

    getAllProducts() {
        return this.http.get<any>(this.appUrl + 'products')
            .toPromise()
            .then(res => res);
    }

    deleteOpportunity(id) {
        return this.http.delete<any>(this.appUrl + id)
            .toPromise()
            .then(res => res);
    }

    getAllUnits() {
        return this.http.get<any>(this.appUrl + 'units')
            .toPromise()
            .then(res => res);
    }

    getAllBusinesses() {
        return this.http.get<any>(this.appUrl + 'allBusinesses')
            .toPromise()
            .then(res => res);
    }

    updateOpportunity(o) {
        return this.http.put<any>(this.appUrl, o)
            .toPromise()
            .then(res => res);
    }

    updateOpportunityStage(item, companyId) {
        item.organizationId = companyId;
        item.StageId = item.oppurtunityStageId;
        const obj = {
            "id": 0,
            "createdSource": "",
            "createdBy": 0,
            "createdDate": new Date(),
            "organizationId": companyId,
            "objectRecordId": item.id,
            "objectId": 0,
            "comment": "",
            "isPublic": true,
            "stageId": item.oppurtunityStageId,
            "userName": "",
            "statusId": 0
        }
        let url = this.appUrl + "EditOpportunityStage?Id=" + item.id + "&organizationId=" + companyId + "&stageId=" + item.oppurtunityStageId;
        return this.http.put<any>(url, obj, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    updateOpporunityStageWithComment(item) {
        let url = this.appUrl + "EditOpportunityStage?Id=" + item.objectRecordId + "&organizationId=" + item.organizationId + "&stageId=" + item.stageId
        return this.http.put<any>(url, item, {
            headers: this.headers
        })
    }

    getOpportunityStageReasonComment(organizationId, opportunityId, stageId) {
        return this.http.get<any>(this.appUrl + 'GetStageReasonComment?organizationId=' + organizationId + '&opportunityId=' + opportunityId + '&stageId=' + stageId)
            .toPromise()
            .then(res => res);
    }

    getOpportunityContacts() {
        return this.http.get<any>(this.appUrl + 'opportunityContacts')
            .toPromise()
            .then(res => res);
    }

    getOpportunityTasks() {
        return this.http.get<any>(this.appUrl + 'opportunityTasks')
            .toPromise()
            .then(res => res);
    }

    getAllAccounts(data) {
        return this.http.get<any>(this.accountApiUrl + 'All', { params: { ...data } })
            .toPromise()
            .then(res => res);
    }

    /* updateContact(c) {
      return this.http.put<any>(this.appUrl + 'opportunityContacts/' + c.id, c)
        .toPromise()
        .then(res => res);
    } */

    addOpportunity(o) {
        return this.http.post<any>(this.appUrl, o)
            .toPromise()
            .then(res => res);
    }

    /* addContact(c) {
      return this.http.post<any>(this.appUrl + 'opportunityContacts', c)
        .toPromise()
        .then(res => res);
    } */

    /* deleteContact(c) {
      return this.http.delete<any>(this.appUrl + 'opportunityContacts/' + c.id)
        .toPromise()
        .then(res => res);
    } */

    /* updateTask(c) {
      return this.http.put<any>(this.appUrl + 'opportunityContacts/' + c.id, c)
        .toPromise()
        .then(res => res);
    } */

    getStatusCommentsForActiveInactive(id) {
        return this.http.get<any>(`${this.appUrl}Opportunity/StatusAudit?id=${id}`)
            .toPromise()
            .then(res => res);
    }

    activeInactiveOpportunity(id, data) {
        let url = `${environment.opportunityUrl}Opportunity/ChangeActiveInactiveStatus/${id}`;
        return this.http.post(url, data)
            .toPromise()
            .then(res => res);
    }

    getActiveInactiveDataByName(name) {
        return this.http.get<any>(`${environment.opportunityUrl}Group/Name?name=` + name);
    }

    getActiveInactiveReasons(groupId) {
        return this.http.get<any>(`${environment.opportunityUrl}Category?groupId=` + groupId);
    }

    addActiveInactiveReason(data) {
        return this.http.post<any>(`${environment.opportunityUrl}Category`, data);
    }

    updateActiveInactiveReason(data) {
        return this.http.put<any>(`${environment.opportunityUrl}Category`, data);
    }

    deleteActiveInactiveReason(id) {
        return this.http.delete<any>(`${environment.opportunityUrl}Category/${id}`);
    }

    getOpportunityContactById(id: number) {
        return this.http.get<any>(`${environment.opportunityUrl}opportunity/GetContactsByOpportunityId/${id}`);
    }

    getOpportunityMLAIScore(opportunityId: number) {
        return this.http.get(`${environment.mlAPI}Scoring/opportunity/${opportunityId}`);
    }
}
